import { format } from "date-fns";
import { useEffect, useState } from "react";
import { DataGrid, Tooltip, Icon } from "../../../components";
import { filtrosUrl, PermisoesHelper } from "../../../helpers";
import { ListLayout } from "../../../layouts";
import { EventosFiscaisService, history } from "../../../services";
import { formatDate, responseErros } from "../../../utils";
import { FormFiltroAvancado } from "./components";

const permissoesHelper = new PermisoesHelper();
const eventosFiscaisService = new EventosFiscaisService();

const ListEventosFicaisView = () => {
  const [eventosFiscais, setEventosFiscais] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const status = [
    {
      nome: "ENVIADA",
      label: "Enviado",
      cor: "#4FBB53",
    },
    {
      nome: "CANCELADO",
      label: "Cancelado",
      cor: "#DC3545",
    },
  ];
  const colunas = [
    {
      field: "status",
      headerName: "Status",
      sortable: true,
      align: "center",
      headerAlign: "center",
      flex: 70,
      renderCell: (params) => obterIconeStatus(params.value),
    },
    {
      field: "numeroDocumento",
      headerName: "Codigo",
      flex: 70,
      filtrar: true,
    },
    {
      field: "descricaoEvento",
      headerName: "Descrição do Evento",
      flex: 400,
      filtrar: true,
    },
    {
      field: "createdAt",
      headerName: "Data do Evento",
      align: "center",
      headerAlign: "center",
      flex: 200,
      valueGetter: (params) =>
        params.value
          ? format(formatDate.received(params.value), "dd/MM/yyyy")
          : "",
    },
  ];

  useEffect(() => {
    const filtros = filtrosUrl.get();
    buscarEventosFiscais(filtros);
  }, []);

  function obterIconeStatus(status) {
    switch (status) {
      case "ENVIADA":
        return (
          <Tooltip title="Enviada" arrow placement="right">
            <Icon>
              <i
                className="ph-fill ph-circle"
                style={{ color: "#4FBB53", fontSize: 18 }}
              ></i>
            </Icon>
          </Tooltip>
        );
      case "CANCELADO":
        return (
          <Tooltip title="Cancelada" arrow placement="right">
            <Icon>
              <i
                className="ph-fill ph-circle"
                style={{ color: "#DC3545", fontSize: 18 }}
              ></i>
            </Icon>
          </Tooltip>
        );
    }
  }

  const buscarEventosFiscais = async function (filter) {
    setLoading(true);
    const result = await eventosFiscaisService.getAll(filter);
    if (!result.isAxiosError) {
      setEventosFiscais(result.data.rows);
      setRowCount(result.data.count);
      filtrosUrl.set(filter);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const onClickCadastrarEventoFiscal = function () {
    history.push("/faturamento/eventos-fiscais/create");
  };

  const onClickEditEventoFiscal = function (id) {
    history.push(`/faturamento/eventos-fiscais/${id}`);
  };

  const sendServerDatagrid = (props) => {
    if (props.tipoFiltro == "simples") {
      buscarEventosFiscais(props.filtros);
    } else {
      buscarPesquisaAvancada(props.filtros);
    }
  };

  const buscarPesquisaAvancada = async (filter) => {
    setLoading(true);
    const porIntervalo = [];
    const filtrosAvancadosTemp = {
      ...filter,
    };
    if (
      filtrosAvancadosTemp.createdAtStart &&
      filtrosAvancadosTemp.createdAtEnd
    ) {
      porIntervalo.push({
        coluna: "createdAt",
        de: filtrosAvancadosTemp.createdAtStart,
        ate: filtrosAvancadosTemp.createdAtEnd,
      });
    }
    const result = await eventosFiscaisService.getAllFiltroAvancado({
      ...filtrosAvancadosTemp,
      restritiva: true,
      porIntervalo,
    });
    if (!result.isAxiosError) {
      setEventosFiscais(result.data.rows);
      setRowCount(result.data.count);
      filtrosUrl.set(filter);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  return (
    <ListLayout
      title="Eventos Fiscais"
      loading={loading}
      onClickCadastrar={onClickCadastrarEventoFiscal}
      permissaoButton={permissoesHelper.temPermisao("nf-saida-cadastrar")}
    >
      <DataGrid
        rows={eventosFiscais}
        columns={colunas}
        onClickEdit={onClickEditEventoFiscal}
        visualizarShow={permissoesHelper.temPermisao("nf-saida-visualizar")}
        editShow={permissoesHelper.temPermisao("nf-saida-editar")}
        paginationMode={"server"}
        rowCount={rowCount}
        sendServer={(props) => sendServerDatagrid(props)}
        FormFiltroAvancado={FormFiltroAvancado}
        listaStatus={status}
      />
    </ListLayout>
  );
};

export default ListEventosFicaisView;
